/* eslint-disable react/prefer-stateless-function */

import React from 'react';
import MaskedInput from 'react-text-mask';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
// import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    width: 160,
  },
});

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={['(', /[0-9]/, /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]}
       placeholderChar={'\u2000'}
       showMask
    />
  );
}
TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix="$"
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

class PhoneInput extends React.Component {
  state = {
    textmask: ' ',
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });

    this.props.onBlur(event);
  };

  render() {
    const { classes, t } = this.props;
    const { textmask /*, numberformat */} = this.state;

    return (
        <FormControl className={classes.formControl} style={this.props.style}>
          <InputLabel htmlFor="formatted-text-mask-input" style={this.props.labelStyle}
           shrink={false}
          >{t("Unplugged.Popup.PhoneNumber")}</InputLabel>
          <Input
            readOnly={this.props.readOnly}
            value={this.props.defaultValue || textmask}
            onChange={this.handleChange('textmask')}
            onBlur={this.props.onBlur}
            onKeyDown={this.props.onKeyDown}
            id={this.props.id}
            name={this.props.name}
            inputComponent={TextMaskCustom}
          />
        </FormControl>
    );
  }
}

PhoneInput.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(PhoneInput));



// WEBPACK FOOTER //
// ./src/components/common/PhoneInput.js